<template>
  <size-picker
    :options="values"
    :active-option="activeFilter.values"
    @select="toggleFilter"
  />
</template>

<script>
import FilterMixin from '@/mixins/filter'
import SizePicker from '@/components/sizePicker/SizePicker'
export default {
  components: {
    SizePicker
  },
  mixins: [
    FilterMixin
  ],
  computed: {
    activeOption() {
      let result = null
      for (let option of this.values) {
        if (this.isEnabled(option)) {
          result = option
          break
        }
      }
      return result
    }
  }
}
</script>
